//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadCommits } from '@/api/miniProgramManagement.js';
export default {
  data() {
    return {
      loading: false,
      show: false,
      form: { user_version: '', user_desc: '' },
      required: {},
      rules: {
        // user_version: [{ required: true, message: '请输入版本号', trigger: 'change' }],
        // user_desc: [{ required: true, message: '请输入版本描述', trigger: 'change' }],
      },
    };
  },
  methods: {
    showdialog(req, data) {
      this.required = req;
      this.form = data;
      this.show = true;
    },
    close() {
      this.show = false;
      this.$refs.form.resetFields();
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        const req = {
          ...this.required,
          body: JSON.stringify(this.form),
        };
        console.log('提交数据:', req);
        uploadCommits(req)
          .then(() => {
            this.close();
            this.loading = false;
            this.$emit('submit');
          })
          .catch(() => {
            this.loading = false;
            this.$message.error('上传失败');
          });
      });
    },
  },
};
